module.exports = __webpack_public_path__ + "static/img/13.003de91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/13.png
// module id = rhWF
// module chunks = 0